<template>
    <b-row no-gutters class="login-row">
        <b-col align-self="center" class="px-3 text-center">
            <br>
            <img :src="logo" alt="logo-moregiros" class="logo-small">
            <b-form id="formForgot" @submit.stop.prevent="submit" class="form-signin mt-4 mb-2">
                <p class="mb-4 d-block text-secondary">{{ labels.text }}</p>
                <b-form-group>
                    <b-form-input
                        id="email"
                        name="email"
                        type="email"
                        v-model="form.email"
                        class="text-center"
                        :placeholder="labels.email"
                        v-validate="'required:true|email'"
                        :state="validateState('email')"
                        aria-describedby="email-live-feedback"
                        :data-vv-as="(labels.email).toLowerCase()"
                        :disabled="loading"
                        size="lg"
                        autofocus/>
                    <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-link :to="form.email ? {name: 'Login', query: {email: form.email}} : {name: 'Login'}" :disabled="loading"
                        class="mt-4 d-block">
                    <i class="mdi mdi-shield-key v-align-baseline"></i>
                    <span>{{labels.recovery}}</span>
                </b-link>
            </b-form>
        </b-col>

        <!-- login buttons -->
        <b-row class="mx-0 bottom-button-container">
            <b-col>
                <b-button type="submit" variant="default" size="lg" pill block class="shadow"
                          form="formForgot" :disabled="loading">
                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                    <span aria-hidden="true" v-else>
                        <i class="mdi mdi-autorenew"></i>
                    </span>
                    <span class="v-align-baseline">{{ loading ? labels.load : labels.login }}</span>
                </b-button>
            </b-col>
        </b-row>
        <!-- login buttons -->
    </b-row>
</template>

<script>
import axios from 'axios';

export default {
    name: "Forgot",
    data: () => ({
        logo: '/img/logo_login.png',
        labels: {
            text: 'Por favor, escriba su correo electrónico. Recibirá un enlace para crear una nueva contraseña.',
            email: 'Correo Electrónico',
            recovery: '¿Recordaste tu contraseña?',
            load: 'Enviando Enlace...',
            login: 'Restablecer'
        },
        form: {
            email: null
        },
        loading: false
    }),
    created() {
        this.form.email = this.$route.query.email || null;
    },
    mounted() {
        this.loginRow();
        window.addEventListener("resize", this.loginRow);
        this.$emit('loader');
    },
    methods: {
        loginRow() {
            $('.login-row').css('min-height', ($(window).height() - 80));
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.form = {
                email: null,
                password: null
            };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) { return; }
                this.loading = true;
                axios.post('/api/password/email', this.form).then((res) => {
                    let msg = 'Se han enviado instrucciones a su correo electrónico para restablecer la contraseña.';
                    this.$root.$bvToast.toast(msg, {
                        title: 'Felicitaciones',
                        headerClass: 'd-none',
                        variant: 'success',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.success();
                }).catch(err => {
                    this.loading = false;
                });
            });
        },
        success() {
            this.$router.push({ name: 'Login' });
        }
    }
}
</script>

<style scoped>

</style>
